import { baseApi } from "./base.api";

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({ url: "/auth/login", method: "POST", body }),
    }),
    resetPassword: build.mutation({
      query: (body) => ({ url: "/auth/reset-password", method: "POST", body }),
    }),
    changePassword: build.mutation({
      query: ({ code, ...body }) => ({ url: `/auth/change-password/${code}`, method: "POST", body }),
    }),
    fetchPermissions: build.mutation({
      query: (body) => ({ url: "/permissions/fetch", method: "POST", body }),
providesTags: ["Permission"],
    }),
    assignPermissions: build.mutation({
      query: (body) => ({ url: "/permissions/assign", method: "POST", body }),
invalidatesTags: ["Permission"],
    }),
    checkPermissions: build.query({
      query: () => ({ url: "/permissions/check-permissions", method: "GET" }),
providesTags: ["Permission"],
    }),
  }),
});

export const {
  useLoginMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useFetchPermissionsMutation,
  useAssignPermissionsMutation,
  useCheckPermissionsQuery,
} = authApi;
